export const Functions = {
  create: false,
  delete: false,
  detail: false,
  search: true,
};

export const PageName = '管理员登录日志';
